import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const HIGHLIGHTCARDBLOCK_LEGACY_FIELD_ORDER = [
  "link_url",
  { type: 'separator' },
  "title",
  "title_size",
  { type: 'separator' },
  "description",
  "description_size",
  { type: 'separator' },
  "image",
  "text_color",
  "background_color",
  "display_cta_icon"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  highlightCardBlockDescriptor: _generatedHighlightCardBlockDescriptor,
  highlightCardBlockBlocDefinition,
  highlightCardBlockDashboardLayout,
  highlightCardBlockConfig,
  highlightCardBlockResolveConfig,
  highlightCardBlockProperties,
} = doodBlockConfig(
  {
    name: "Highlight card",
    componentType: 'HighlightCardBlockComponent',
    category: 'content',
    description: "Highlight card.",
    keywords: [],
    allowedIn: [
      { bloc: "ShopCardsBlockComponent", slot: "shops" },
    ],
    sharedFields: {}
  },

  () => ({
    link_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.highlight-card.link-url.label",
      }
    }),
    title: propertyValue({
      type: 'textarea',
      value: '',
      options: {
        label: "pages.blocks.highlight-card.title.label",
        rows: 2
      }
    }),
    title_size: propertyValue({
      type: 'select',
      value: "M",
      options: {
        label: "pages.blocks.highlight-card.title-size.label",
        choices: [
          {
            value: "S",
            label: "pages.blocks.highlight-card.title-size.options.S",
          },
          {
            value: "M",
            label: "pages.blocks.highlight-card.title-size.options.M",
          },
          {
            value: "L",
            label: "pages.blocks.highlight-card.title-size.options.L",
          }
        ]
      }
    }),
    description: propertyValue({
      type: 'textarea',
      value: '',
      options: {
        label: "pages.blocks.highlight-card.description.label",
        rows: 2
      }
    }),
    description_size: propertyValue({
      type: 'select',
      value: "S",
      options: {
        label: "pages.blocks.highlight-card.description-size.label",
        choices: [
          {
            value: "S",
            label: "pages.blocks.highlight-card.description-size.options.S",
          },
          {
            value: "M",
            label: "pages.blocks.highlight-card.description-size.options.M",
          },
          {
            value: "L",
            label: "pages.blocks.highlight-card.description-size.options.L",
          }
        ]
      }
    }),
    image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.highlight-card.image.label",
        help: "pages.blocks.highlight-card.image.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.highlight-card.text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.highlight-card.background-color.label",
        help: "pages.blocks.highlight-card.background-color.help",
      }
    }),
    display_cta_icon: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.highlight-card.display-cta-icon.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.highlight-card.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.highlight-card.fieldset.link.label",
            fields: ["link_url"],
          },
          {
            legend: "pages.blocks.highlight-card.fieldset.title.label",
            fields: ["title", "title_size", "text_color"],
          },
          {
            legend: "pages.blocks.highlight-card.fieldset.description.label",
            fields: ["description", "description_size"],
          },
          {
            legend: "pages.blocks.highlight-card.fieldset.image.label",
            fields: ["image", "background_color"],
          },
          {
            legend: "pages.blocks.highlight-card.fieldset.cta-icon.label",
            fields: ["display_cta_icon"],
          },
        ],
      },
    ],
  })
);

export function highlightCardBlockDescriptor(): IBlockDescriptor;
export function highlightCardBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function highlightCardBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedHighlightCardBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedHighlightCardBlockDescriptor, highlightCardBlockProperties, fieldOrder);
}

export {
  highlightCardBlockBlocDefinition,
  highlightCardBlockDashboardLayout,
  highlightCardBlockProperties,
  highlightCardBlockConfig,
  highlightCardBlockResolveConfig,
};

export type HighlightCardBlockConfig = typeof highlightCardBlockConfig;
